import { BaseApi } from '@shared/config';
import type {
  GetCandidateReviewsRequest,
  GetCandidateReviewsResponse,
} from './types';

class CandidateReviewApi extends BaseApi {
  getCandidateReviews = (
    params: GetCandidateReviewsRequest
  ): Promise<GetCandidateReviewsResponse> => {
    return this.instance.get('candidates-rating', { params });
  };
}

export const candidateReviewApi = new CandidateReviewApi();
